import { cn } from "@/lib/utils";

export default function DataRowActions({ actions = [], item, compact = false, className }) {
  const visibleActions = actions.filter((action) => !action.hidden?.(item));
  if (visibleActions.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap items-center gap-2", compact ? "justify-end" : "justify-start", className)}>
      {visibleActions.map((action) => {
        const Icon = action.icon;
        return (
          <button
            key={action.key || action.label}
            type="button"
            onClick={() => action.onClick?.(item)}
            data-testid={typeof action.testId === "function" ? action.testId(item) : action.testId}
            className={cn(
              "inline-flex min-h-9 items-center gap-1.5 rounded-lg border border-border px-2.5 text-[11px] font-mono uppercase tracking-wider transition-colors",
              compact && "min-h-7 px-2 normal-case tracking-normal",
              action.destructive
                ? "hover:border-destructive/60 hover:text-destructive"
                : "hover:border-foreground/40 hover:text-foreground",
              action.className
            )}
          >
            {Icon && <Icon className="h-3.5 w-3.5" strokeWidth={1.5} />}
            <span>{action.label}</span>
          </button>
        );
      })}
    </div>
  );
}
